// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"134":"8e59374d","297":"370f4b44","349":"4a30b339","683":"91203b2b","836":"bfc6ccfe"}[chunkId] + ".css";
};